module.exports = __webpack_public_path__ + "static/media/bg.2c890d73.jpg";